import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../NTFS/ntfs.scss";
import {
  SET_AZURE_TENANT_ID,
  SET_WORKSPACE_ID,
} from "../../../redux/constants/constants";
import DynamicFormField from "../NTFS/DynamicFormField";

const MSSentinalConfiguration = ({ errorObj, setErrorObj }) => {
  const dispatch = useDispatch();

  const { workSpaceId, azureTenantId } = useSelector(
    (state) => state.tenantSignUpReducer
  );

  const [showWorkspace, setShowWorkspace] = useState(false);
  const [showTenant, setShowTenant] = useState(false);

  const toggleWorkspaceVisibility = () => {
    setShowWorkspace((prev) => !prev);
  };

  const toggleTenantVisibility = () => {
    setShowTenant((prev) => !prev);
  };

  const handleWorkspaceChange = (e) => {
    dispatch({
      type: SET_WORKSPACE_ID,
      payload: e.target.value,
    });
  };

  const handleTenantChange = (e) => {
    dispatch({
      type: SET_AZURE_TENANT_ID,
      payload: e.target.value,
    });
  };

  return (
    <div className="ntfsMainContainer">
      <h2 className="ntfsHeading">Microsoft Sentinel Configuration</h2>
      <div className="ntfsS3fieldContainer">
        <DynamicFormField
          label="Workspace ID"
          value={workSpaceId || ""}
          type="password"
          placeholder="Enter Workspace ID"
          onChange={handleWorkspaceChange}
          showPassword={showWorkspace}
          togglePasswordVisibility={toggleWorkspaceVisibility}
          important={false}
        />

        <DynamicFormField
          label="Azure Tenant ID"
          value={azureTenantId || ""}
          type="password"
          placeholder="Enter Azure Tenant ID"
          onChange={handleTenantChange}
          showPassword={showTenant}
          togglePasswordVisibility={toggleTenantVisibility}
          important={false}
        />
      </div>
    </div>
  );
};

export default MSSentinalConfiguration;